<template>
  <div class="food-manage">
    <div class="tuolele-main-search tuolele-main-search-item">
      <p style="color:#666666">姓名: <span style="margin-left: 10px;">{{ childInfo.sub_name }}</span></p>
      <p style="color:#666666;margin-top:5px;font-size:16px">积分: <span style="margin-left: 10px; color:#F56C6C;">{{ childInfo.score }}</span></p>
    </div>
    <el-table :key="tableKey" :data="lists" border stripe>
      <el-table-column label="流水ID" prop="flow_id" align="center" />
      <el-table-column label="积分变动" prop="value" align="center" />
      <el-table-column label="详情" prop="content" align="center" />
      <el-table-column label="操作人" prop="editor_name" align="center" />
      <el-table-column label="操作时间" prop="create_time" align="center" />
    </el-table>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetPenaltyList" />
    </div> -->

  </div>

</template>
<script>

// import Select from '@/components/Select'

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'
// const defaultSetBonusPenaltySubmitPostForm = {
//   id: '',
//   content: '',
//   score: '0'
// }
export default {
  name: 'TurnStudentList',
  components: {
    // Select
  },
  props: {
    subId: {
      type: String,
      default: ''
    },
    subName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      dialogVisible1: false,
      total: 0,
      childInfo: {
        sub_name: '',
        score: ''
      },
      listQuery: {
        p: 1,
        limit: 20,
        sub_id: ''
      }

    }
  },
  created() {
    this.listQuery.sub_id = this.subId || this.$route.query.sub_id
    this.childInfo.sub_name = this.subName || this.$route.query.sub_name
    this.fnGetPointManageList()
  },
  methods: {
    fnGetPointManageList: function() {
      this.$http.getPointManageFlow(this.listQuery).then(res => {
        this.lists = res.data.list
        this.childInfo.score = res.data.info.point
        // this.total = parseInt(res.data.count)
      })
    },
    fnFollow() {

    },
    fnUpdate(row) {

    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
</style>
